import { render, staticRenderFns } from "./coreForm.vue?vue&type=template&id=12c8da52&scoped=true"
import script from "./coreForm.vue?vue&type=script&lang=js"
export * from "./coreForm.vue?vue&type=script&lang=js"
import style0 from "./coreForm.vue?vue&type=style&index=0&id=12c8da52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8da52",
  null
  
)

export default component.exports